import React from 'react';
import _ from 'lodash';

import PropTypes from 'prop-types';

import Rows from './Rows';

const Table = ({ pageLayout, data, removeData }) => {
  const handleRemoveData = orderID => removeData(orderID);

  return (
    <div className="responsive-table-container quote-approval-table-container">
      <table className="responsive-table">
        <caption className="responsive-table__caption">
          {`${_.get(pageLayout, 'tableTitle', '')} (${data.length})`}
        </caption>
        <thead className="responsive-table__thead">
          <tr>
            <th></th>
            {_.get(pageLayout, 'tableHeaders', []).map(header => (
              <th key={_.get(header, 'sys.id', '')}>
                {_.get(header, 'fields.title', '')}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="responsive-table__tbody">
          {data &&
            data.map((order, index) => (
              <Rows
                key={order.id}
                index={index}
                order={order}
                pageLayout={pageLayout}
                removeData={handleRemoveData}
                headers={_.get(pageLayout, 'tableHeaders', []).map(
                  item => item.fields.title
                )}
              />
            ))}
        </tbody>
      </table>
    </div>
  );
};

Table.propTypes = {
  pageLayout: PropTypes.objectOf(PropTypes.object).isRequired,
  removeData: PropTypes.func.isRequired,
  data: PropTypes.objectOf(PropTypes.array).isRequired
};

export default Table;
